export const UPDATE_NAVIGATION_REQUEST = 'UPDATE_NAVIGATION_REQUEST';
export const updateNavigationRequest = (payload) => ({
    type: UPDATE_NAVIGATION_REQUEST,
    payload,
});
